import { Component} from 'vue-property-decorator';
import { StripeElements, StripeElement } from 'vue-stripe-elements-plus';
import ProductItem  from '../../product-item.vue';
import Payment from '../../payment.component';
import { getRelated } from '@/shared/data/plan-utils';


@Component({
  components: {
    StripeElements,
    StripeElement,
    ProductItem
  }
})
export default class LearnerStratergy extends Payment {
  public async subscriptionsToItems() {
    this.subscriptionItems = [];


    // need to redo this logic
    for (const key in this.subscriptions) {
      const sub = this.subscriptions[key];
      this.cantChange = !(sub.status === 'expired');
      const item = this.allPlans.find((val) => val.priceId === sub.plan.stripeId);

      if (item) {
        let authorQty = 0;
        const learnerQty = this.getAddonQuantity(sub.addons, 'learnerCount');
        console.log('learnerQty:', learnerQty);
        const learnerAuthorList = item.price.metadata && item.price.metadata.learnerAuthorList ?
              JSON.parse(item.price.metadata.learnerAuthorList) : null;

        if (learnerAuthorList && learnerQty) {
          const author = learnerAuthorList.find((val) => val.learner === learnerQty);
          if (author && sub.quantity > author.author) {
            authorQty = sub.quantity - author.author;
          }
        }
        const related = getRelated(this.allPlans, item);
        const relatedAuthor = this.buildSubscriptionItem(related['relatedAuthor'], authorQty, null);
        const relatedLearner = this.buildSubscriptionItem(related['relatedLearner'],1, null);
        const subsItem = this.buildSubscriptionItem(item, learnerQty, sub.id);
        subsItem.relatedAuthor = relatedAuthor;
        subsItem.relatedLearner = relatedLearner;

        this.billingCycle = item.price.recurring.interval;

        this.subscriptionItems.push(subsItem);
        if (relatedAuthor) {
          relatedAuthor.unitAmount = this.formatPrice(relatedAuthor.unitPrice);
          this.subscriptionItems.push(relatedAuthor);
        }
      }
    }
  }

}
